import { onReady } from "@/utils/dom";
import { initNavbar } from "@/modules/navbar";
import { initScrollToTop } from "@/modules/scroll-to-top";
import { initContactForm } from "@/modules/contact-form";

onReady(() => {
  initNavbar();
  initScrollToTop();
  initContactForm();
});
